let $_checkDevEvent = function(){
        let _result = false,
            _hostname = location.hostname;

        if( _hostname === '127.0.0.1' || _hostname === 'localhost' ) {
            _result = true;
        }

        return _result;
    },
    _devEvent = $_checkDevEvent();

let _ApiUrl = _devEvent? 'http://10.153.196.209:2020/salenet_api': location.origin +'/salenet_api',
    _webSocketServiseUrl =  _devEvent? 'http://10.153.196.230/dom': 'https://ecwebsocket.fpcetg.com.tw/mod',
    _exportUrl = _devEvent? 'https://ec.fpcetg.com.tw/ecfrontapitest/account/login': 'https://ec.fpcetg.com.tw/ecfrontapi/account/login',
    // _talkDomainUrl = 'https://fpcimmember.fpcetg.com.tw',
    _talkDomainUrl = 'https://im.fpcetg.com.tw',
    _talkAccountUrl = _talkDomainUrl +'/fpcimapi/getAccountInfo',
    _talkLoginUrl = _talkDomainUrl +'/fpcimapi/login';

export default {
    install: function(Vue, options) {
        Vue.prototype.$siteConfig = this;
    },
    devEvent: _devEvent, //是不是測試模式
    ApiUrl: _ApiUrl,
    webSocketServiseUrl: _webSocketServiseUrl,
    exportUrl: _exportUrl,
    talkDomainUrl: _talkDomainUrl,
    talkAccountUrl: _talkAccountUrl,
    talkLoginUrl: _talkLoginUrl,
    emptyProductPhoto: process.env.BASE_URL +'images/emptyProduct.png',
    allowanceTable: {
        18: {
            PE: {
                0: 0,
                15000: -0.2,
                30000: -0.3,
                50000: -0.4,
                75000: -0.45,
                100000: -0.5,
                200000: -0.55,
                300000: -0.6,
                1000000: -0.65,
                2000000: -0.7,
            },
            EVA: {
                0: 0,
                10000: -0.3,
                30000: -0.5,
                50000: -0.7,
                100000: -1.0,
            }
        },
    },
}